import { useState, useEffect, useMemo } from "react";

function getResponsiveTickInterval(dataLength: number, isMobile: boolean): number {
  if (isMobile) {
    if (dataLength <= 7) return 0;
    if (dataLength <= 14) return 1;
    if (dataLength <= 30) return 3;
    if (dataLength <= 60) return 6;
    return Math.floor(dataLength / 8);
  }
  if (dataLength <= 14) return 0;
  if (dataLength <= 30) return 1;
  if (dataLength <= 60) return 2;
  return Math.floor(dataLength / 20);
}

export function useResponsiveTickInterval(dataLength: number): number {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 640 : false
  );

  useEffect(() => {
    const mql = window.matchMedia("(max-width: 639px)");
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return useMemo(
    () => getResponsiveTickInterval(dataLength, isMobile),
    [dataLength, isMobile]
  );
}
